import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const bar = style({
  position: 'relative',
  height: '0.9rem',
  marginBottom: '1rem',
});

const barBackground = style({
  width: '100%',
  height: '100%',
  backgroundColor: themeVars.color.semantic.surface.neutral30,
  borderRadius: '0.9rem',
});

const barProgress = style({
  position: 'absolute',
  top: 0,
  left: 0,
  width: 0,
  height: '0.9rem',
  backgroundColor: themeVars.color.semantic.surface.accentSecondary30,
  borderRadius: '0.9rem',
  transition: 'width 0.6s ease-in-out',
});

const containerTitle = style({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '3rem',
});

const iconBadge = style({
  marginRight: '1.6rem',
});

const infoIcon = style({
  marginLeft: '0.8rem',
});

const containerBudget = style({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '1.4rem',
  marginTop: '0.4rem',
});

const textRenewal = style({
  marginBottom: '0.8rem',
});

const containerReachedLimit = style({
  marginBottom: '2.4rem',
});

export const css = {
  bar,
  barBackground,
  barProgress,
  containerTitle,
  iconBadge,
  infoIcon,
  containerBudget,
  textRenewal,
  containerReachedLimit,
};
